import Actions from "../Actions";
import {MessageBarType} from "office-ui-fabric-react";

const adminReducer = (state: {show: boolean, message: string, messageBarType: MessageBarType} | undefined, action: {type: string,message: string,messageBarType: MessageBarType,actions?: JSX.Element}) => {

    if(state === undefined)
    {
        return {
            show: false,
            message: "",
            messageBarType: MessageBarType.info,
            actions: undefined
        };
    }

    switch (action.type)
    {
        case Actions.SHOW_MESSAGE_BAR:
            return Object.assign({},state,{show: true, message: action.message, messageBarType: action.messageBarType, actions: action.actions});
        case Actions.HIDE_MESSAGE_BAR:
            return Object.assign({},state, {show: false,message: '',messageBarType: MessageBarType.info,actions: undefined});
        default:
            return state;
    }
};

export default adminReducer;
